export enum ExternalSystemItemMappingType {
Tax,
Product,
}
